import React, { useEffect } from 'react';
import Portal from './Portal';

export default function DrawerShell({ visible, onClose, children }) {
  useEffect(() => {
    if (!visible) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <Portal>
      <div className="drawer-scrim" onClick={onClose} />
      <div className="drawer">
        {children}
      </div>
    </Portal>
  );
}
